import ReportPage from './ReportPage'

export default function NotaFiscalReport({className = ''}: {className?: string}) {
  return <ReportPage type='notafiscal' className={className} />
}
